// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Qt-z","giftOrPromoSelector":"Rt-z","disabled":"St-z","subTitle":"Tt-z","selectShipAddressMessage":"Ut-z","changePayment":"Vt-z"};